import { useContext, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/Button';
import { BeneficiariesProvider } from '../../providers/beneficiaries';
import { ProfileStore } from '../../providers/profile';
import SubmittedSuccessful from '../widgets/beneficiaries/SubmittedSuccessful/SubmittedSuccessful';
import SelectBeneficiary from '../widgets/retireOnlineStepper/reitreOnlineStep4/selectBeneficiary';

const HsaInvestmentView = () => {
  const [isSubmitted, setSubmitted] = useState(false);
  const { hsaList, setHsaList } = useContext(ProfileStore);

  const navigate = useNavigate();

  const handleData = (data: any) => {
    setHsaList(data);
  };

  return (
    <Container className="cnd-custom-container px-7 px-lg-0 pt-lg-12 mt-11 mt-lg-12">
      {!isSubmitted && (
        <>
          <SelectBeneficiary
            data={hsaList}
            collectStepData={handleData}
            title={'HSA Investment'}
            subtitle={
              'Choose your beneficiary to receive payments from this plan'
            }
            quote={
              "If you don't make an election and you die the remaining payment will be made first to your designated beneficiary and if your beneficiary is dead then to your Estate."
            }
          />
          <section className="d-flex flex-column flex-lg-row justify-content-center mb-12">
            <Button
              variant="primary-outline"
              className={`mx-lg-10order-2 order-lg-1 mt-7 mt-lg-0`}
              onClick={() => navigate(-1)}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              className={'mx-lg-10 order-3 order-lg-2 mt-7 mt-lg-0'}
              onClick={() => {
                setSubmitted(true);
              }}
            >
              Save
            </Button>
          </section>
        </>
      )}
      {isSubmitted && (
        <>
          <SubmittedSuccessful spouseSelected={false} />
          <section className="d-flex flex-column flex-lg-row justify-content-center mb-12">
            <Button
              variant="primary"
              className={'mx-lg-10 order-3 order-lg-2 mt-7 mt-lg-0'}
              onClick={() => {
                navigate(-1);
              }}
            >
              Back to Beneficiaries
            </Button>
          </section>
        </>
      )}
    </Container>
  );
};

const HsaInvestment = () => {
  return <BeneficiariesProvider>
    <HsaInvestmentView />
  </BeneficiariesProvider>;
};

export default HsaInvestment;
